export const MEMBERSHIP_TYPES_RESET_STATE = 'MEMBERSHIP_TYPES_RESET_STATE';
export const MEMBERSHIP_TYPES_CURRENT_ITEM = 'MEMBERSHIP_TYPES_CURRENT_ITEM';
 
export const MEMBERSHIP_TYPES_REQUEST_LOADING = 'MEMBERSHIP_TYPES_REQUEST_LOADING';
export const MEMBERSHIP_TYPES_REQUEST_SUCCESS = 'MEMBERSHIP_TYPES_REQUEST_SUCCESS';
export const MEMBERSHIP_TYPES_REQUEST_FAILED = 'MEMBERSHIP_TYPES_REQUEST_FAILED';
 
export const MEMBERSHIP_TYPES_CURRENT_ACTION = 'MEMBERSHIP_TYPES_CURRENT_ACTION';
export const MEMBERSHIP_TYPES_RESET_ACTION = 'MEMBERSHIP_TYPES_RESET_ACTION';